import { render, staticRenderFns } from "./van-volxem.vue?vue&type=template&id=6b75ff92&scoped=true"
import script from "./van-volxem.vue?vue&type=script&lang=js"
export * from "./van-volxem.vue?vue&type=script&lang=js"
import style0 from "./van-volxem.vue?vue&type=style&index=0&id=6b75ff92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b75ff92",
  null
  
)

export default component.exports